module.exports = __webpack_public_path__ + "static/media/navlogout.b23f0a4e.svg";